import api from './api'

const payrollService = {
  // 計算單一員工薪資
  calculatePayroll: async (data) => {
    return api.post('/payroll/calculate', data)
  },

  // 批次產生薪資
  generatePayroll: async (data) => {
    return api.post('/payroll/generate', data)
  },

  // 取得薪資記錄列表
  getRecords: async (params) => {
    return api.get('/payroll/records', { params })
  },

  // 取得單筆薪資記錄
  getRecord: async (id) => {
    return api.get(`/payroll/records/${id}`)
  },

  // 核准薪資記錄
  approveRecord: async (id) => {
    return api.post(`/payroll/records/${id}/approve`)
  },

  // 標記為已發放
  markPaid: async (id) => {
    return api.post(`/payroll/records/${id}/paid`)
  },

  // 批次核准
  batchApprove: async (recordIds) => {
    return api.post('/payroll/batch-approve', { record_ids: recordIds })
  },

  // 取得統計資料
  getStatistics: async (params) => {
    return api.get('/payroll/statistics', { params })
  },

  // 取得薪資結構
  getSalaryStructure: async (params) => {
    return api.get('/payroll/structures', { params })
  },

  // 建立薪資結構
  createSalaryStructure: async (data) => {
    return api.post('/payroll/structures/create', data)
  },

  // 取得薪資組成項目
  getComponents: async (params) => {
    return api.get('/payroll/components', { params })
  },

  // 建立自訂薪資組成項目
  createComponent: async (data) => {
    return api.post('/payroll/components/create', data)
  },
}

export default payrollService
